module.exports = __webpack_public_path__ + "img/icon@2x.dc072ef8.png";